<template >
    <div class="PageNotFound">
        not
    </div>
</template>
<script>
export default {
    name: 'PageNotFound'
}
</script>
<style lang="sass">
    
</style>